import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeGenerator = ({ userId, name, centerName, examName, url = `https://ebda-edu.com/checkin?user_id=` }) => {
    const canvasRef = useRef(null);
    const wholeUrl = `${url}${userId}`;

    const handleDownload = () => {
        const canvas = canvasRef.current?.querySelector("canvas");
        if (!canvas) return;

        // Create a new canvas to composite text and QR code
        const padding = 20;
        const headerHeight = 100; // Space for text
        const newCanvas = document.createElement("canvas");
        const ctx = newCanvas.getContext("2d");
        const size = canvas.width;
        
        newCanvas.width = size + padding * 2;
        newCanvas.height = size + headerHeight + padding * 2;

        // Fill background
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);

        // Draw text
        ctx.fillStyle = "#000000";
        ctx.textAlign = "center";
        
        // Name
        ctx.font = "bold 20px Arial";
        ctx.fillText(name || "Candidate", newCanvas.width / 2, 40);

        // Exam Name
        if (examName) {
            ctx.font = "16px Arial";
            ctx.fillText(examName, newCanvas.width / 2, 70);
        }

        // Center Name
        if (centerName) {
            ctx.font = "14px Arial";
            ctx.fillText(centerName, newCanvas.width / 2, 95);
        }

        // Draw QR Code
        ctx.drawImage(canvas, padding, headerHeight + padding);

        // Download
        const pngUrl = newCanvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `QR_Code_${name}.png`;
        downloadLink.click();
    };

    return (
        <div className="text-center m-4 border p-4 rounded shadow flex flex-col justify-center items-center bg-white">
            <h3 className="font-bold text-lg mb-1">{name}</h3>
            {examName && <p className="text-sm font-semibold text-gray-700">{examName}</p>}
            {centerName && <p className="text-xs text-gray-500 mb-2">{centerName}</p>}
            
            <div ref={canvasRef} className="p-2 bg-white">
                <QRCodeCanvas value={wholeUrl} size={200} level="H" includeMargin={true} />
            </div>
            
            <p className="text-xs mt-2 text-gray-400 break-all max-w-[200px]">{wholeUrl}</p>
            <button
                onClick={handleDownload}
                className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition shadow-sm font-medium"
            >
                Download Label
            </button>
        </div>
    );
};

export default QRCodeGenerator;